import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconOpenInNew.tsx
const OutlinedFilledOpenInNew = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M189-95q-39.05 0-66.53-27.47Q95-149.95 95-189v-582q0-39.46 27.47-67.23Q149.95-866 189-866h270v95H189v582h582v-270h95v270q0 39.05-27.77 66.53Q810.46-95 771-95H189Zm216-244-65-66 366-366H519v-95h347v347h-95v-186L405-339Z" })
});
const OutlinedOpenInNew = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M189-95q-39.05 0-66.53-27.47Q95-149.95 95-189v-582q0-39.46 27.47-67.23Q149.95-866 189-866h270v95H189v582h582v-270h95v270q0 39.05-27.77 66.53Q810.46-95 771-95H189Zm216-244-65-66 366-366H519v-95h347v347h-95v-186L405-339Z" })
});
const RoundedFilledOpenInNew = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M189-95q-39.05 0-66.53-27.47Q95-149.95 95-189v-582q0-39.46 27.47-67.23Q149.95-866 189-866h223q19.75 0 33.38 14.26 13.62 14.27 13.62 34 0 19.74-13.62 33.24Q431.75-771 412-771H189v582h582v-223q0-19.75 13.68-33.38Q798.35-459 818.09-459q19.73 0 33.82 13.62Q866-431.75 866-412v223q0 39.05-27.77 66.53Q810.46-95 771-95H189Zm582-610L438-371q-14.78 14-32.89 13T373-373q-14-14-14-32.5t14-32.5l333-333H566q-19.75 0-33.37-13.68Q519-798.35 519-818.09q0-19.73 13.63-33.82Q546.25-866 566-866h252q19.63 0 33.81 14.19Q866-837.63 866-818v252q0 19.75-14.26 33.37-14.27 13.63-34 13.63-19.74 0-33.24-13.63Q771-546.25 771-566v-139Z" })
});
const RoundedOpenInNew = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M189-95q-39.05 0-66.53-27.47Q95-149.95 95-189v-582q0-39.46 27.47-67.23Q149.95-866 189-866h223q19.75 0 33.38 14.26 13.62 14.27 13.62 34 0 19.74-13.62 33.24Q431.75-771 412-771H189v582h582v-223q0-19.75 13.68-33.38Q798.35-459 818.09-459q19.73 0 33.82 13.62Q866-431.75 866-412v223q0 39.05-27.77 66.53Q810.46-95 771-95H189Zm582-610L438-371q-14.78 14-32.89 13T373-373q-14-14-14-32.5t14-32.5l333-333H566q-19.75 0-33.37-13.68Q519-798.35 519-818.09q0-19.73 13.63-33.82Q546.25-866 566-866h252q19.63 0 33.81 14.19Q866-837.63 866-818v252q0 19.75-14.26 33.37-14.27 13.63-34 13.63-19.74 0-33.24-13.63Q771-546.25 771-566v-139Z" })
});
const SharpFilledOpenInNew = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M95-95v-771h364v95H189v582h582v-270h95v364H95Zm310-244-65-66 366-366H519v-95h347v347h-95v-186L405-339Z" })
});
const SharpOpenInNew = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M95-95v-771h364v95H189v582h582v-270h95v364H95Zm310-244-65-66 366-366H519v-95h347v347h-95v-186L405-339Z" })
});
const componentMap = {
	outlined: OutlinedOpenInNew,
	"outlined-fill": OutlinedFilledOpenInNew,
	rounded: RoundedOpenInNew,
	"rounded-fill": RoundedFilledOpenInNew,
	sharp: SharpOpenInNew,
	"sharp-fill": SharpFilledOpenInNew
};
const IconOpenInNew = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconOpenInNew };